import {ApiClient} from '@hconnect/apiclient'
import {HttpError} from '@hconnect/common/types'
import {useQuery, keepPreviousData} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment'

import {QueryOptions2Type} from '../../../shared/types/common.types'
import {SignalTelemetry} from '../types/sensor.types'

import {usePlantUpmId} from './usePlantUpmId'

export const QueryKey = 'telemetry'

export const useGetTelemetry = (
  localNames: string[],
  options?: QueryOptions2Type<SignalTelemetry[], AxiosError<HttpError>>
) => {
  const plantUpmId = usePlantUpmId()

  return useQuery<SignalTelemetry[], AxiosError<HttpError>>({
    queryKey: [QueryKey, plantUpmId, localNames],
    queryFn: async () => {
      const path = `/kms/${plantUpmId}/signal/last-values`
      return (
        await ApiClient.axiosInstance.post(path, {
          localNames,
          cadAlertQueryLimit: moment().subtract(6, 'hours').toISOString()
        })
      ).data
    },
    placeholderData: keepPreviousData,
    refetchInterval: 1000 * 60,
    ...options
  })
}
